import moment from 'moment';

export const EXPIRACION_RULES = {
  required: 'Este campo es obligatorio',
  validate: (value) => {
    if (value.includes('_')) {
      return 'Debe ingresar los 6 digitos';
    } else {
      const mes = moment().get('M') + 1;
      const anio = moment().get('y');
      const mesExpiracion = Number(value.split('/')[0]);
      const anioExpiracion = Number(value.split('/')[1]);

      const anioValido = anio + 10;

      if (mesExpiracion < 1 || mesExpiracion > 12) {
        return 'Ingrese un mes válido';
      }

      if (anioExpiracion < anio || anioExpiracion > anioValido) {
        return `Ingrese un año válido entre ${anio} y ${anioValido}`;
      }

      if (anioExpiracion === anio) {
        if (mesExpiracion < mes) {
          return 'La fecha de expiración debe ser mayor o igual a la fecha actual';
        }
      }

      if (anioExpiracion < anio) {
        return 'La fecha de expiración debe ser mayor o igual a la fecha actual';
      }
    }
    return true;
  },
};

export const CVV_RULES = (cvvLongitud) => ({
  required: 'Este campo es obligatorio',
  maxLength: {
    value: cvvLongitud,
    message: `Solo se puede ingresar ${cvvLongitud} números`,
  },
  minLength: {
    value: cvvLongitud,
    message: `Debe ingresar ${cvvLongitud} números`,
  },
});

export const MEDIOS_PAGO = {
  pago: 'pago',
  suscripcion: 'suscripcion',
  pagoTradicional: 'pagoTradicional',
};

export const SUB_MEDIOS_PAGO = {
  correo: 'correo',
  tarjeta: 'tarjeta',
};

export const SUB_MEDIOS_PAGO_KEYS = {
  tarjeta: {
    label: 'Ingresar tarjeta',
    value: 'tarjeta',
  },
  correo: {
    label: 'Enviar correo a cliente para solicitar pago',
    value: 'correo',
  },
};

export const SUB_MEDIOS_PAGO_OPTIONS = [
  {
    label: 'Enviar correo a cliente para solicitar pago',
    value: 'correo',
  },
  {
    label: 'Ingresar tarjeta',
    value: 'tarjeta',
  },
].map((item) => ({ ...item, value: item }));
